export const DETAILED_STATISTICS = {
  missingLabReport: {
    stats: [
      'testsWithReport',
      'testsWithoutReportAndPartLab',
      'testsWithoutReportButPartLab',
      'testsCancelledWithoutReport'
    ],
    name: 'missingLabReport',
    hasBoundaries: false
  },
  testsToSchedule: {
    stats: [
      'testsScheduledOrDone',
      'testsToScheduleWithoutPartLab',
      'testsToScheduleWithPartLab'
    ],
    name: 'testsToSchedule',
    hasBoundaries: false
  },
  scheduledTestsToDo: {
    stats: [
      'testsDone',
      'testsToDoWithoutPartLab',
      'testsToDoWithPartLab',
      'testsToDoWithoutDateAndCancelled'
    ],
    name: 'scheduledTestsToDo',
    hasBoundaries: false
  },
  lateTests: {
    stats: [
      'testsLateWithoutPartLab',
      'testsLateWithPartLab'
    ],
    name: 'lateTests',
    hasBoundaries: true
  },
  testsBillTodo: {
    stats: [
      'testsBillTodo',
      'testsBillTodoAndCancelled'
    ],
    name: 'testsBillTodo',
    hasBoundaries: true
  },
  projectedTests: {
    stats: [
      'testsOrdered',
      'testsWithoutOrderFormAndPartLab',
      'testsWithoutOrderFormButPartLab'
    ],
    name: 'projectedTests',
    hasBoundaries: false
  }
}

export const getHasBoundariesByStat = stat => {
  return Object.values(DETAILED_STATISTICS).find(detailedStat => detailedStat.stats.includes(stat))?.hasBoundaries ?? false
}

export const COLUMN_CHART_AXIS_LABEL = [
  'lessThan5Days',
  'lessThan15Days',
  'lessThan30Days',
  'moreThan30Days'
]

export const getStats = () => {
  const stats = [];
  Object.keys(DETAILED_STATISTICS).map(ds => stats.push(...DETAILED_STATISTICS[ds].stats));
  return stats;
}